<template>
  <div id="app" class="transition-mode-bg">
    <div class="top-header transition-mode-bg"></div>
    <div class="bg-content"></div>
    <div class="bottom-footer transition-mode-bg"></div>
    <svg-radius-component
      position="radius-top-left transition-mode-color"
    /><svg-radius-component
      position="radius-top-right transition-mode-color"
    /><svg-radius-component
      position="radius-bottom-right transition-mode-color"
    /><svg-radius-component
      position="radius-bottom-left transition-mode-color"
    /><router-view
      @cursor-enter="handleCursorEnter"
      @showContent="showContent"
    /><loading-screen-component />
    <div
      class="custom-cursor"
      :class="{ incard: isInCard }"
      :style="cursorStyle"
    ></div>
    <toggle-mode-dark-component v-if="isContentVisible" /><footer-component
      @cursor-enter="handleCursorEnter"
      v-if="isContentVisible"
    />
  </div>
</template><script>
import FooterComponent from "./components/footerComponent.vue";
import LoadingScreenComponent from "./components/LoadingScreenComponent.vue";
import SvgRadiusComponent from "./components/svgRadiusComponent.vue";
import ToggleModeDarkComponent from "./components/toggleModeDarkComponent.vue";

export default {
  components: {
    LoadingScreenComponent,
    FooterComponent,
    ToggleModeDarkComponent,
    SvgRadiusComponent,
  },

  name: "HomeView",
  data() {
    return {
      cursorX: 0,
      cursorY: 0,
      smoothCursorX: 0,
      smoothCursorY: 0,
      isCursorVisible: true,
      isInCard: false,
      isContentVisible: true,
    };
  },

  computed: {
    cursorStyle() {
      return {
        left: `$ {
          this.smoothCursorX
        }

        px`,
        top: `$ {
          this.smoothCursorY
        }

        px`,
        opacity: this.isCursorVisible ? 1 : 0,
      };
    },
  },

  mounted() {
    this.hideComponentsIfNeeded();
    window.addEventListener("mousemove", this.updateCursorPosition);
    window.addEventListener("mouseout", this.hideCursor);
    this.animateCursor();
  },

  beforeDestroy() {
    window.removeEventListener("mousemove", this.updateCursorPosition);
    window.addEventListener("mouseout", this.hideCursor);
  },

  methods: {
    showContent() {
      this.isContentVisible = true;
    },

    hideComponentsIfNeeded() {
      const currentRouteName = this.$route.name;

      if (currentRouteName === "NotFound") {
        this.isContentVisible = false;
      }
    },

    handleCursorEnter(isVisible) {
      this.isInCard = !isVisible;
    },

    updateCursorPosition(event) {
      this.cursorX = event.clientX;
      this.cursorY = event.clientY;
      this.isCursorVisible = true;
    },

    hideCursor() {
      this.isCursorVisible = false;
    },

    animateCursor() {
      const easeFactor = 0.15;
      this.smoothCursorX += (this.cursorX - this.smoothCursorX) * easeFactor;
      this.smoothCursorY += (this.cursorY - this.smoothCursorY) * easeFactor;
      requestAnimationFrame(this.animateCursor);
    },
  },
};
</script>